export const ANALYTICS_CONSENT_KEY = "namaste_analytics_consent";
export const ANALYTICS_CONSENT_EVENT = "namaste:analytics-consent";

const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
let loadPromise;
let lastFirstPartyView = { path: "", at: 0 };

export function getAnalyticsConsent() {
  if (typeof window === "undefined") return null;
  return window.localStorage.getItem(ANALYTICS_CONSENT_KEY);
}

export function setAnalyticsConsent(value) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(ANALYTICS_CONSENT_KEY, value);
  if (measurementId) {
    window[`ga-disable-${measurementId}`] = value !== "accepted";
  }
  if (value === "rejected") {
    document.cookie.split(";").forEach((cookie) => {
      const name = cookie.split("=")[0].trim();
      if (name === "_ga" || name.startsWith("_ga_")) {
        document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax`;
        document.cookie = `${name}=; Max-Age=0; path=/; domain=.namastenetwork.ai; SameSite=Lax`;
      }
    });
  }
  window.dispatchEvent(new CustomEvent(ANALYTICS_CONSENT_EVENT, { detail: value }));
}

export function initializeAnalytics() {
  if (!measurementId || typeof window === "undefined") return Promise.resolve(false);
  if (getAnalyticsConsent() !== "accepted") return Promise.resolve(false);
  if (loadPromise) return loadPromise;
  window[`ga-disable-${measurementId}`] = false;

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", measurementId, { send_page_view: false });

  loadPromise = new Promise((resolve) => {
    const existing = document.querySelector(`script[data-namaste-ga="${measurementId}"]`);
    if (existing) {
      resolve(true);
      return;
    }
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.dataset.namasteGa = measurementId;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.head.appendChild(script);
  });

  return loadPromise;
}

export async function trackPageView(path) {
  const preference = getAnalyticsConsent();
  const pagePath = String(path || "/").split(/[?#]/)[0] || "/";
  const now = Date.now();
  if (preference !== "rejected" && (lastFirstPartyView.path !== pagePath || now - lastFirstPartyView.at > 10000)) {
    lastFirstPartyView = { path: pagePath, at: now };
    fetch("/api/analytics/page-view", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: pagePath }),
      keepalive: true,
    }).catch(() => {});
  }
  if (preference !== "accepted") return;
  const ready = await initializeAnalytics();
  if (!ready || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_location: window.location.href,
    page_path: path,
    page_title: document.title,
  });
}
